var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17c0 1.5-1 2-2.5 2h-13C1.9 19 1 18.5 1 17c0-4 4.5-7 9-7s9 3 9 7zM14 5c0 2.2-1.8 4-4 4S6 7.2 6 5s1.8-4 4-4 4 1.8 4 4z"
  })));
};
export default SvgUser;